import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PlacesAutocomplete from 'react-places-autocomplete';
import classnames from 'classnames';

import withGoogleMaps from 'client/helpers/withGoogleMaps';

const SrAddressSearchAutocompleteSuggestion = ({ suggestionAddress, isFirst }) => (
  <div className={classnames('addressSearchSuggestion', isFirst && 'addressSearchSuggestionFirst')}>
    <span className="addressSearchSuggestionIcon" />
    <span>{suggestionAddress}</span>
  </div>
);

SrAddressSearchAutocompleteSuggestion.propTypes = {
  suggestionAddress: PropTypes.string.isRequired,
};

SrAddressSearchAutocompleteSuggestion.displayName = 'SrAddressSearchAutocompleteSuggestion';

@withGoogleMaps
class SrAddressSearchAutocomplete extends Component {
  static propTypes = {
    onSelect: PropTypes.func.isRequired,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    currentUserMarket: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      value: '',
    };
  }

  componentWillUnmount() {
    this._isUnmounting = true;
  }

  _onChange = (value) => {
    const { onChange } = this.props;
    if (this._isUnmounting) {
      return;
    }
    this.setState({
      value,
    });
    if (onChange) {
      onChange(value);
    }
  };

  _onCancelClick = () => {
    this._onChange('');
  };

  _onSelect = (address, placeId) => {
    const { onSelect } = this.props;
    const input = this.state.value;
    if (this._isUnmounting) {
      return;
    }
    onSelect({ input, address, placeId });
  };

  _onError = (status, clearSuggestions) => {
    clearSuggestions();
  };

  render() {
    const { disabled, googleMaps, currentUserMarket } = this.props;
    const { value } = this.state;
    const searchOptions = {
      componentRestrictions: {
        country: 'us',
      },
    };

    if (googleMaps) {
      const coordinates = currentUserMarket.serviceZone.coordinates;
      searchOptions.bounds = new googleMaps.LatLngBounds();
      coordinates.forEach((coord) => {
        searchOptions.bounds.extend(new googleMaps.LatLng(coord[1], coord[0]));
      });
      searchOptions.strictBounds = true;
    }

    return (
      <div>
        <PlacesAutocomplete
          value={value}
          onChange={this._onChange}
          onSelect={this._onSelect}
          onError={this._onError}
          // developers.google.com/maps/documentation/javascript/reference/#AutocompletionRequest
          searchOptions={searchOptions}
        >
          {({ getInputProps, getSuggestionItemProps, suggestions, loading }) => (
            <div className="addressSearchInputContainer">
              <input
                {...getInputProps({
                  className: 'addressSearchInput',
                  placeholder: 'Address...',
                  disabled: disabled,
                })}
              />
              {value && (
                <span
                  onClick={disabled ? null : this._onCancelClick}
                  className={classnames(
                    'addressSearchInputCancel',
                    disabled && 'addressSearchInputCancelDisabled',
                  )}
                >
                  Cancel
                </span>
              )}
              {!disabled && (
                <div className="autoCompleteContainer">
                  {loading && (
                    <div className="searchLoading">
                      <span>searching...</span>
                    </div>
                  )}
                  {suggestions.map((suggestion, index) => {
                    // TODO suggestion.matchedSubstrings -> [{ length: 2, offset: 0 }]
                    return (
                      <div {...getSuggestionItemProps(suggestion)} key={suggestion.index}>
                        <SrAddressSearchAutocompleteSuggestion
                          isFirst={index === 0}
                          suggestionAddress={suggestion.description}
                        />
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}
        </PlacesAutocomplete>
      </div>
    );
  }
}

SrAddressSearchAutocomplete.displayName = 'SrAddressSearchAutocomplete';

export default SrAddressSearchAutocomplete;
